(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["image-content-new"] && !window.DesignMode) return;
  try {
    

{
  theme.AjaxCart = new window.AjaxCart(
  $("#AddToCartForm-home-1")
    );
}
{
  theme.AjaxCart = new window.AjaxCart(
  $("#AddToCartForm-home-2")
    );
}
{
  theme.AjaxCart = new window.AjaxCart(
  $("#AddToCartForm-home-3")
    );
}

  } catch(e) { console.error(e); }
})();

})();
